var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14",
    width: 18,
    height: 4.93827,
    rx: 2.46914,
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    y: 7.71899,
    width: 32,
    height: 4.48759,
    rx: 2.2438,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16",
    y: 14.3354,
    width: 32,
    height: 4.48759,
    rx: 2.2438,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 14_2",
    x: 36,
    width: 28,
    height: 19.7531,
    rx: 4.44444,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M0 30.6029C0 28.1483 1.98985 26.1584 4.44444 26.1584H59.5553C62.0099 26.1584 63.9997 28.1483 63.9997 30.6029V31.1393H0V30.6029Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 9",
    y: 32.1355,
    width: 63.9997,
    height: 3.98467,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16_2",
    y: 37.1162,
    width: 63.9997,
    height: 3.98467,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    y: 42.4692,
    width: 63.9997,
    height: 3.98467,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 18",
    y: 47.4075,
    width: 63.9997,
    height: 3.98467,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 19",
    y: 52.3457,
    width: 63.9997,
    height: 3.98467,
    fill: "#F2F2F2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.10ddef5799de29cbc0e668b1a37ea712.svg";
export { ForwardRef as ReactComponent };